import React from 'react';
import { useTranslation } from 'next-i18next';

import Box from '@mui/material/Box';
import type { TypographyProps } from '@mui/material';

import Typography from 'src/components/ui/Typography';
import { colours } from 'src/constants/colours';
import formatDistanceToNow from 'src/utils/formatDistanceToNow';

type GalleryData = {
    id: string;
    numberOfContents: number;
    contentLastUpdatedAt?: Date;
};

type GalleryPreviewDataInfosProps = {
    gallery: GalleryData;
    useCaptionVariant?: boolean;
    dateFontSize?: string;
    gapBetweenSubtitleAndDate?: string;
};
export const GalleryPreviewDataInfos: React.FC<GalleryPreviewDataInfosProps> = ({
    gallery,
    useCaptionVariant,
    dateFontSize,
    gapBetweenSubtitleAndDate = '0.7rem',
}) => {
    const { t, i18n } = useTranslation(['favorites']);

    const style = {
        subtitleVariant: (useCaptionVariant ? 'caption' : 'body2') as TypographyProps['variant'],
        dateVariant: (useCaptionVariant ? 'caption' : 'subtitle2') as TypographyProps['variant'],
    };

    return (
        <Box display="flex" gap={gapBetweenSubtitleAndDate} alignItems="center">
            <Typography
                data-target-id={`favorite-card-subtitle-id-${gallery.id}`}
                variant={style.subtitleVariant}
                style={{ color: colours.black.main }}
                noWrap
            >
                {t('favorites:countGalleries', {
                    count: gallery.numberOfContents,
                    plurial: gallery.numberOfContents > 1 ? 's' : '',
                })}
            </Typography>
            {gallery.contentLastUpdatedAt && (
                <Typography
                    data-target-id={`favorite-card-date-id-${gallery.id}`}
                    variant={style.dateVariant}
                    color={colours.grey.G600}
                    fontSize={dateFontSize}
                    noWrap
                >
                    {formatDistanceToNow(
                        String(gallery.contentLastUpdatedAt),
                        i18n.language as SupportedLangs,
                        false,
                        false,
                    )}
                </Typography>
            )}
        </Box>
    );
};
